import { ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from 'vuex';
export default {
  name: 'goTopPC',
  setup() {
    const store = useStore();
    const windowTop = ref(0);
    const onScroll = e => {
      windowTop.value = e.target.documentElement.scrollTop;
    };
    const backToTop = () => {
      if (windowTop.value > 100) window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    onMounted(() => {
      window.addEventListener('scroll', onScroll);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', onScroll);
    });
    return {
      windowTop,
      backToTop,
      store
    };
  }
};